module.exports = __webpack_public_path__ + "static/media/credentialing-vendors-alerts.83ad16f8.svg";